import {loggedInUserInList, loggedInUserId} from "../auth/msalConfig";

export const canEditInitiative = (initiativeTeam) => {
  return loggedInUserInList(initiativeTeam.filter(item => item.role !== 'Viewer'));
};

export const isOwnerOrEditor = (initiativeTeam) => {
  return loggedInUserInList(initiativeTeam.filter(item => item.role === 'Owner' || item.role === 'Editor'));
};

export const isTo = (initiativeTeam) => {
  return loggedInUserInList(initiativeTeam.filter(item => item.role === 'TO'));
};

export const isWsl = (initiativeTeam) => {
  return loggedInUserInList(initiativeTeam.filter(item => item.role === 'WSL'));
};

export const isOidLoggedInUser = (oid) => {
  return loggedInUserId() === oid;
};
